<template>
    <div class="home">
        <div class="mask" :class="{'show-warning' : showWarning}"></div>
        <!--<div class="home-overlay"></div>-->
        <div class="content">
            <div class="container">
                <div class="row text-center mobile-margin-auto text-uppercase" v-if="siteInfos.reduction_active">
                    <div class="col-md-12">
                        <h2 class="">
                            A partir de <b>2 produits</b> achetés : <b>15% de remise</b>
                        </h2>
                    </div>
                </div>
                <div class="row mobile-margin-auto">
                    <div class="router-link-container col-6 col-md-6 col-lg-4 col-xl-3" v-for="link in links.filter(el => el.is_active)">

                        <div class="router-link" v-if="link.Prefix !== 'sav'">
                            <router-link :to="'/constructor/'+link.Prefix+'/etape1'">
                                <img :src="'https://api.laboutiquerenovart.fr/'+link.Image"/>
                            </router-link>
                            <p class="choice-link"><span>{{link.Nom}}</span></p>

                            <div class="choice-list text-left" v-html="link.Description"></div>

                            <router-link :to="'/constructor/'+link.Prefix+'/etape1'" class="choice-link-button">
                                Configurer
                            </router-link>
                        </div>

                        <div class="router-link" v-if="link.Prefix === 'sav'">
                            <a @click="checkPrevent($event, '/constructor/'+link.Prefix+'/etape1')">
                                <img :src="'https://api.laboutiquerenovart.fr/'+link.Image"/>
                            </a>
                            <p class="choice-link"><span>{{link.Nom}}</span></p>

                            <div class="choice-list text-left" v-html="link.Description"></div>

                            <a class="choice-link-button"
                               @click="checkPrevent($event,'/constructor/'+link.Prefix+'/etape1')">
                                Configurer
                            </a>
                        </div>
                    </div>

                    <div class="router-link-container col-6 col-md-6 col-lg-4 col-xl-3" v-for="link in links.filter(el => !el.is_active)">
                        <router-link tag="div" :to="'#'" class="router-link coming">
                            <img :src="'https://api.laboutiquerenovart.fr/'+link.Image"/>
                            <p class="choice-link">{{link.Nom}}</p>
                            <p class="choice-link coming">Prochainement</p>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="popup-valid" :class="{'show-warning' : showWarning}">
            <h4 class="beforeStarting">Attention!</h4>
            <p>Vous ne pouvez pas ajouter une réparation/diagnostic dans une configuration de produits.</p>

            <p>Merci de terminer votre configuration de produits en cliquant sur le bouton « Voir mes produits »</p>
            <button class="btn main" @click="togglewWarningModal()">J'ai compris</button>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'PreConstructor',
        data() {
            return {
                showWarning: false
            }
        },

        computed: {
            siteInfos() {
                return this.$store.state.siteInfos
            },
            links() {
                return this.$store.state.families
            },
            products() {
                return this.$store.state.products
            },
            hasProducts() {
                return this.products.length > 0
            },
            hasSav() {
                return this.hasProducts && this.products.some(prod => prod.productType === "sav")
            }
        },
        methods: {
            click() {
            },
            togglewWarningModal() {
                this.showWarning = !this.showWarning
            },

            checkPrevent(e, link) {
                if (this.hasProducts && !this.hasSav) {
                    this.togglewWarningModal()
                } else {
                    this.$router.push(link)
                }
            }
        }
    }
</script>

<style>

    .popup-valid.show-warning, .mask.show-warning {
        display: block;
    }

    .displayNone {
        display: none;
    }

    .error {
        color: red;
    }

    div.popup-valid {
        display: none;
        /* width: 40%; */
        /* margin: 50px auto; */
        /* box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.4); */
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
        transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
        background-color: #ffffff;
        padding: 60px 25px;
        text-align: center;
        font-family: sans-serif;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border: 1px solid #efefef;
        border-radius: 3px;
        z-index: 21;
    }

    .mask {
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.5);
        position: fixed;
        top: 0;
        z-index: 20;
        display: none;
        margin-left: 0;
    }

    .popup-valid:hover {
        box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    }

    .popup-valid .title {
        font-size: 24px;
        margin-bottom: 20px;
    }

    .popup-valid form {
        width: 90%;
        margin: 0 auto;
    }

    .popup-valid form input {
        height: 35px;
        width: 100%;
        padding: 5px 10px;
        display: block;
        box-sizing: border-box;
    }

    .popup-valid .button-list {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
    }

    .popup-valid .button-list .btn {
        display: inline-block;
        font-weight: 400;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        border: 1px solid transparent;
        padding: .375rem .75rem;
        font-size: 1rem;
        line-height: 1.5;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
        background-color: #d8d8d8;
        border-radius: 0;
    }

    .popup-valid .button-list .btn:hover {
        cursor: pointer;
    }

    .popup-valid .button-list .btn.main {
        text-transform: uppercase;
        font-weight: bold;
        border-radius: 3px;
        padding: 10px 20px;
    }

    .popup-valid .button-list .btn:hover.main {
        transition: all .3s;
        background-color: #c4c4c4;
    }

    .popup-valid .button-list .btn:hover {
        background-color: #c4c4c4;
    }

    .choice-list ul, li {
        padding: 0;
        margin: 0;
    }

    .choice-list ul {
        list-style: none;
        margin-left: 0;
        padding-left: 0;
        margin-bottom: 10%;
    }

    .choice-list li {
        padding-left: 1em;
        text-indent: -1em;
    }

    .choice-list li:before {
        content: "\f00c";
        font-family: FontAwesome;
        padding-right: 5px;
    }

    .choice-link {
        height: 50px;
        width: 100%;
        display: table;
        margin-bottom: 0.75rem;
    }

    .choice-link > span {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }

    a.choice-link-button {
        display: block;
        width: 70%;
        text-decoration: none;
        padding: 15px 10px;
        background: #2d2d2d;
        color: #fff !important;
        font-weight: bold;
        position: relative;
        margin: 0 0 10px 10px;
        letter-spacing: 1px;
    }

    .choice-link-button:hover {
        transition: all .3s;
        text-decoration: none;
        color: #efefef;
        background: #3d3d3d;
    }

    .choice-link-button:before {
        content: '';
        display: block;
        width: 20px;
        height: 2px;
        position: absolute;
        left: -10px;
        top: 50%;
        transform: translateY(-50%);
    }

    .home {
        height: 92%;
    }

    .router-link {
        width: 100%;
        padding: 10px 7px 10px 7px;
        /* min-height: 500px; */
        cursor: pointer;

    }

    .router-link img {
        height: auto;
        width: 100%;
    }

    .router-link p {
        margin-top: 20px;
        text-transform: uppercase;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
    }

    .home-overlay {
        position: fixed;
        width: 100%;
        height: 100%;
        content: '';
        top: 0;
        bottom: 0;
        background-image: url("../../public/img/landing/bg-header.jpg");
        background-size: cover;
        z-index: 0;
        filter: grayscale(100%);
    }

    @media screen and (min-width: 0\0
    ) and (min-resolution: +72dpi) {
        .home-overlay {
            background: url("../../public/img/landing/bg-header-bw.jpg") no-repeat center;
        }
    }

    .content {
        position: relative;
        z-index: 6;
        padding: 50px 0 50px 0;
    }

    .content h2 {
        width: 100%;
        color: #000;
        padding: 20px;
    }

    .choices-container {
        width: 80%;
        flex-wrap: wrap-reverse;
        height: auto;
        margin: 0 auto;
    }

    .home .choice {
        width: 260px;
        height: 260px;
        margin: 0 auto;
    }

    .router-link {
        flex: 1 0 20%;
        margin: 5px 1%;
    }

    .router-link:first-child {
        margin: 5px 0%;
    }

    .choice-link.coming {
        margin: 0;
        font-style: italic;
    }

    .router-link.coming {
        border-color: lightgray;
        cursor: not-allowed;
    }

    .router-link.coming img {
        opacity: 0.5;
    }

    .router-link.coming .choice-link {
        margin-bottom: 0;
        font-style: italic;
        color: grey;
        word-break: break-word;
    }

    /*Reduce preconstrucor cards size */
    @media screen and (max-width: 1200px) {
        .home .content h2 {
            font-size: 1.5rem;
            padding: 5px;
        }
        .content {
            padding: 20px 0 50px 0;
        }
        .home .router-link img {
            max-height: 20vh;
            object-fit: cover;
        }
        .home .router-link p {
            margin-top: 0;
            margin-bottom: 0;
        }
        .home .choice-list ul {
            margin-bottom: 3%;
        }
        .home a.choice-link-button {
            margin: 0 0 0 10px;
            padding: 10px 10px;
        }
    }

    @media screen and (max-width: 1200px) and (min-width: 990px) and (orientation: landscape)   {
        .router-link-container {
            flex: 0 0 25%;
            max-width: 25%;
        }
    }

    @media screen and (max-width: 575px)   {
        .router-link-container, .col-md-12 {
            padding: 0 5px;
        }
        .router-link {
            padding: 5px 3px 5px 3px;
        }
        .mobile-margin-auto {
            margin: auto
        }
    }

</style>
